import { copyToClipboard, formatPhoneNumber } from '@/lib/utils';
import { VendorContact } from '@/types/vendor.types';
import { Copy } from 'lucide-react';

export const VendorContactsListContent = ({ contacts }: { contacts: VendorContact[] }) => {
  return (
    <div className="flex flex-col gap-4 pt-2">
      {contacts.length > 0 ? (
        <>
          <div className="grid grid-flow-row gap-4 w-full">
            {contacts?.map((contact, index) => (
              <div key={index} className="flex flex-col bg-[#F5F5F5] break-all w-full gap-4 p-3 rounded-md">
                <span className="text-sm font-semibold">{contact.contactName}</span>
                {contact.email && <ContactField value={contact.email} />}
                {contact.phone && <ContactField value={formatPhoneNumber(contact.phone)} />}
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="flex justify-center text-[#676767]">No Contacts</div>
      )}
    </div>
  );
};

const ContactField = ({ value }: { value?: string }) => {
  return (
    <div className="flex justify-between gap-4">
      <span className="text-sm text-[#3B82F6]">{value}</span>
      <div>
        <Copy
          className="cursor-pointer w-5 h-5 text-placeholder"
          onClick={async () => {
            if (value) await copyToClipboard(value);
          }}
        />
      </div>
    </div>
  );
};
